<template>
  <PrintPage :pageNumber="pageNumber">
    <template v-slot:header>
      <slot>
        <PrintHeaderClientSlim :project="project" />
      </slot>
    </template>

    <div class="content-box">
      <div class="content-box-header">
        <h2>7. {{ $t('zs') }} & {{ $t('gak') }}</h2>
      </div>
      <div class="two-column-grid">
        <div>{{ $t('zsLocationState') }}</div>
        <div>{{ $t(project.serviceReport.zsLocationState) }}</div>
      </div>
    </div>

    <AttachmentsPrintGrid
      :attachments="project.zsWithCoverAttachments"
      fieldName="zsWithCoverAttachments"
      :maxImages="4"
    />

    <AttachmentsPrintGrid
      :attachments="project.serviceZsWithoutCoverAttachments"
      fieldName="zsWithoutCoverAttachments"
      :maxImages="4"
    />
  </PrintPage>
</template>

<script>
import PrintPage from '@/components/Print/PrintPage';
import PrintHeaderClientSlim from '@/components/Print/PrintHeaderClientSlim';
import AttachmentsPrintGrid from '@/components/Print/AttachmentsPrintGrid';
import { range } from '@/helpers/math.js';

export default {
  name: 'ElectricMeterPrintPage1',
  components: {
    PrintPage,
    PrintHeaderClientSlim,
    AttachmentsPrintGrid,
  },
  props: {
    project: null,
    pageCount: { type: Number, default: null },
    pageNumber: { type: Number, default: 0 },
  },
  computed: {},
  methods: { range },
};
</script>
